var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3222 14.4127H12.5595C13.3019 14.4127 13.8793 13.8571 13.8793 13.1429V2.26984C13.8793 1.55556 13.3019 1 12.5595 1H5.3832C4.64082 1 4.06342 1.55556 4.06342 2.26984V3.46032",
    fill: "#3399FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3222 14.4127H12.5595C13.3019 14.4127 13.8793 13.8571 13.8793 13.1429V2.26984C13.8793 1.55556 13.3019 1 12.5595 1H5.3832C4.64082 1 4.06342 1.55556 4.06342 2.26984V3.46032",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67256 16.0004H2.49624C1.75386 16.0004 1.17645 15.4449 1.17645 14.7306V4.4925C1.17645 3.77821 1.75386 3.22266 2.49624 3.22266H9.67256C10.4149 3.22266 10.9923 3.77821 10.9923 4.4925V14.7306C10.9923 15.4449 10.4149 16.0004 9.67256 16.0004Z",
    fill: "#3399FF",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconBlue);
export default __webpack_public_path__ + "static/media/copy-icon-blue.ac189d18.svg";
export { ForwardRef as ReactComponent };